// Returns a readable string to describe a given date
export const getTimeDiff = (date, i18nLabels = GLOBALS.LOCALIZATION_LABELS, maxDays = 21) => {
  const diff = Math.abs(new Date().getTime() - date.getTime());

  const units = [
    { name: "day", seconds: 24 * 60 * 60 },
    { name: "hour", seconds: 60 * 60 }
  ];

  if (diff / (1000 * units[0].seconds) > maxDays) {
    return "";
  } else {
    let msg = "";

    units.forEach(unit => {
      const unitDiff = Math.floor(diff / (1000 * unit.seconds));
      if (!msg && unitDiff > 0) {
        const timeLabel = i18nLabels[`${unit.name}${unitDiff > 1 ? "s" : ""}Ago`];
        msg = timeLabel.replace("__numeral__", unitDiff);
      }
    });

    return msg;
  }
};
